// import React, { Component } from 'react';

// class NumberAnimation extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             currentNumber: 0,
//         };
//     }

//     componentDidMount() {
//         this.startAnimation();
//     }

//     componentWillUnmount() {
//         clearInterval(this.interval); // Zamanlayıcıyı temizle
//     }

//     startAnimation = () => {
//         const { targetNumber } = this.props; // Hedef rakamı al
//         this.interval = setInterval(() => {
//             this.setState((prevState) => {
//                 if (prevState.currentNumber < targetNumber) {
//                     return { currentNumber: prevState.currentNumber + 1 };
//                 } else {
//                     clearInterval(this.interval); // Hedefe ulaşıldığında animasyonu durdur
//                     return null;
//                 }
//             });
//         }, 100); // Her 100 milisaniyede bir artır
//     };

//     render() {
//         const { currentNumber } = this.state;

//         return (
//             <div className='bg-[#f4f8fc] p-[12px] rounded-[50%] '>
//                 <span className='text-[20px] font-[700] text-[#0E38B1]' >
//                     {currentNumber}+
//                 </span>
//             </div>
//         );
//     }
// }

// export default NumberAnimation;


import React, { Component } from 'react';

class NumberAnimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentNumber: 0,
        };
    }

    componentDidMount() {
        this.startAnimation();
    }

    componentWillUnmount() {
        clearInterval(this.interval); // Zamanlayıcıyı temizle
    }

    startAnimation = () => {
        const { targetNumber } = this.props; // Hedef rakamı al
        const duration = 2000; // 2 seconds
        const stepTime = duration / targetNumber; // Calculate the interval time

        this.interval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.currentNumber < targetNumber) {
                    return { currentNumber: prevState.currentNumber + 1 };
                } else {
                    clearInterval(this.interval); // Hedefe ulaşıldığında animasyonu durdur
                    return null;
                }
            });
        }, stepTime); // Set the interval based on the step time
    };

    render() {
        const { currentNumber } = this.state;

        return (
            <div className='bg-[#f4f8fc] p-[12px] rounded-[50%]'>
                <span className='text-[20px] font-[700] text-[#0E38B1]'>
                    {currentNumber}+
                </span>
            </div>
        );
    }
}

export default NumberAnimation;